import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import OkInput from "shared/components/oknf/OkInput";
import Str from "shared/components/Str";
import SmsKillSwitchWrapper from "shared/components/SmsKillSwitchWrapper";
import _str from "shared/util/_str";

import TwoFactor from "./TwoFactor";

import { SCREENS, STATUS_CODES } from "apps/login/util/constants";
import BlacklistedTerms from "../BlacklistedTerms";

class Login extends React.Component {
	static propTypes = {
		submitLogin: PropTypes.func.isRequired,
		facebookLogin: PropTypes.func.isRequired,
		phoneLogin: PropTypes.func.isRequired,
		changeField: PropTypes.func.isRequired,
		changeScreen: PropTypes.func.isRequired,
		showFacebookLogin: PropTypes.bool.isRequired,
		showTwoFactor: PropTypes.bool.isRequired,
		isSubmitting: PropTypes.bool.isRequired,
		isLoggedIn: PropTypes.bool.isRequired,
		username: PropTypes.string,
		password: PropTypes.string,
		authcode: PropTypes.string,
		saveAuth: PropTypes.bool,
		error: PropTypes.shape({
			type: PropTypes.number,
			message: PropTypes.string,
		}),
	};

	static defaultProps = {
		username: "",
		password: "",
		authcode: "",
		saveAuth: false,
		error: null,
	};

	_onChangeUsername = (ev) => {
		this.props.changeField("username", ev.target.value);
	};

	_onChangePassword = (ev) => {
		this.props.changeField("password", ev.target.value);
	};

	_showPasswordReset = () => {
		this.props.changeScreen(SCREENS.PASSWORD_RESET);
	};

	_onChangeAuthcode = (value) => {
		this.props.changeField("authcode", value);
	};

	_onChangeSaveAuth = (value) => {
		this.props.changeField("saveAuth", value);
	};

	_submitLogin = (ev) => {
		ev.preventDefault();

		// do nothing if we're submitting already
		if (this.props.isSubmitting) {
			return false;
		}

		if (this.props.showTwoFactor) {
			return this.props.submitLogin();
		}

		// blur the inputs, if the refs exist
		["username", "password"].forEach((field) => {
			if (this[field] && typeof (this[field].blur) === "function") {
				this[field].blur();
			}
		});

		// actually submit
		this.props.submitLogin();

		return null;
	};

	render() {
		const {
			username,
			password,
			facebookLogin,
			showFacebookLogin,
			showTwoFactor,
			isSubmitting,
			isLoggedIn,
			phoneLogin,
			error,
		} = this.props;

		let buttonText = _str("Next");

		if (isSubmitting) {
			buttonText = _str("Submitting…");
		}

		if (isLoggedIn) {
			buttonText = _str("Success!");
		}

		const blackListedError = error?.type === STATUS_CODES.BLACKLISTED;

		return (
			<form
				onSubmit={this._submitLogin}
				className="oknf oknf--gray login-form"
				method="POST"
			>
				{blackListedError && (
					<BlacklistedTerms />
				)}
				<div className="login-fields">
					<div className="login-fields-field">
						<label htmlFor="username" className="login-fields-field-label">{_str("Email")}</label>
						<OkInput
							id="username"
							name="username"
							value={username}
							placeholder="Email"
							autoComplete="off"
							autoCorrect="off"
							autoCapitalize="off"
							autoFocus={process.env.PLATFORM === "desktop"}
							spellCheck="false"
							className="login-fields-field-input login-username"
							onChange={this._onChangeUsername}
						/>
					</div>

					<div className="login-fields-field">
						<label htmlFor="password" className="login-fields-field-label">{_str("Password")}</label>
						<OkInput
							id="password"
							name="password"
							type="password"
							placeholder="Password"
							value={password}
							className="login-fields-field-input login-password"
							onChange={this._onChangePassword}
						/>
					</div>
				</div>

				<div className="login-actions">
					<input
						type="submit"
						value={buttonText}
						disabled={!username || !password}
						className={classnames("login-actions-button", {
							"isSubmitting": isSubmitting,
							"isloggedin": isLoggedIn,
						})}
					/>
					{showTwoFactor &&
						<TwoFactor
							submitLogin={this.props.submitLogin}
							saveAuth={this.props.saveAuth}
							authcode={this.props.authcode}
							onChangeAuthcode={this._onChangeAuthcode}
							onChangeSaveAuth={this._onChangeSaveAuth}
						/>
					}
					{!showTwoFactor &&
						<button
							type="button"
							className="login-fields-field-link"
							onClick={this._showPasswordReset}
						>
							<Str>Forgot password?</Str>
						</button>
					}

					<div className="login-divider"><span>{_str("or")}</span></div>

					{<SmsKillSwitchWrapper>
						<button
							type="button"
							className="login-actions-button login-actions-button-sms"
							onClick={phoneLogin}
						>
							<Str>Log in with phone</Str>
						</button>
					</SmsKillSwitchWrapper>}

					{showFacebookLogin &&
						<button
							type="button"
							className="login-actions-link"
							onClick={facebookLogin}
						>
							<Str>Log in with Facebook</Str>
						</button>
					}
				</div>
			</form>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/apps/login/components/screens/Login.jsx